import { useMediaTrack } from "@daily-co/daily-react";
import type { ReactNode } from "react";

import { BodyText } from "@/components/ui";

import { getTrackUnavailableMessage } from "../utils/utils";
import { MediaView } from "./MediaView";

interface CallPanelTileProps {
  participantId: string;
  isSelf?: boolean;
  placeholder?: ReactNode;
  // For participants that never send video (e.g. an audio-only interpreter)
  hideVideoMessage?: boolean;
}

export const CallPanelTile = ({
  participantId,
  isSelf = false,
  placeholder,
  hideVideoMessage = false,
}: CallPanelTileProps) => {
  const video = useMediaTrack(participantId, "video");
  const audio = useMediaTrack(participantId, "audio");

  const audioUnavailableMessage = getTrackUnavailableMessage("audio", audio);
  const videoUnavailableMessage = hideVideoMessage
    ? undefined
    : getTrackUnavailableMessage("video", video);
  const messages = [audioUnavailableMessage, videoUnavailableMessage].filter(
    Boolean,
  );
  return (
    <>
      <MediaView
        participantId={participantId}
        isSelf={isSelf}
        placeholder={placeholder}
      />
      {!!messages.length && (
        <BodyText className="z-10">{messages.join("\n")}</BodyText>
      )}
    </>
  );
};
